/**
 * Registra o service worker do Hugi (`/sw.js`, H46 fatias 2 e 3) — quem chama é o `main.tsx` de cada app,
 * com `import.meta.env.PROD`: em desenvolvimento um worker ativo atrapalharia o recarregamento do vite.
 *
 * Escopo `/` de propósito: painel e inbox são builds diferentes na MESMA origem, e um worker só cobre os
 * dois — o aviso tocado abre `/atender/<conversa>` mesmo que a pessoa esteja no painel.
 */
export function registrarServiceWorker(emProducao: boolean): void {
  if (!emProducao || typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((erro: unknown) => {
    console.warn(`[sw] não registrou: ${String(erro)}`);
  });
}
